"use client";

import { useRouter } from "next/navigation";
import Button from "@/lib/bwax-ui-next/components/Button";

export default function StartButton() {
    const router = useRouter();

    return (
        <Button className="w-full sm:w-auto !px-12" color="violet" appearance="primary" size="large" onPress={_ => {
            router.push("/u/task")
        }}>
            上传文档
        </Button>
    )
}
